<template>
  <Layout class="main-app-layout">
    <Header class="main-app-header">
      <appHeader />
    </Header>
    <Content class="main-app-content">
      <router-view />
    </Content>
  </Layout>
</template>

<script>
import appHeader from "./header"
export default {
  components: { appHeader },
  data() {
    console.log("conponent")
    return {}
  },
}
</script>

<style>
.main-app-layout {
  height: 100vh;
  overflow: hidden;
  background: #fff;
}
.main-app-header {
  padding: 0 10px;
  height: 50px;
}
.main-app-content {
  padding: 5px;
  overflow: auto;
}
</style>